"use strict";

require("es6-promise/auto");

require("core-js/es6/map");

require("core-js/es6/set");

require("raf/polyfill");

var _ramda = require("ramda");

var _reactDom = require("react-dom");

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-console */

if (typeof window.fundsMarketingConfiguration === 'undefined') {
  window.fundsMarketingConfiguration = { gaiaRedirectUrl: "" };
}

// eslint-disable-next-line no-undef,camelcase
__webpack_public_path__ = window.fundsMarketingConfiguration.gaiaRedirectUrl || window.fundsMarketingConfiguration.gaiaRedirectUrl === "" ? window.fundsMarketingConfiguration.gaiaRedirectUrl + "/" : "/FundsMarketingHandler/";

// noinspection BadExpressionStatementJS
import( /* webpackChunkName: "styles" */ // eslint-disable-line no-inline-comments
'./styles/base.scss');

console.trace("Test Source Mapping");

window.mountFundsMarketingApp = function (fundsMarketingConfiguration) {
  window.fundsMarketingConfiguration = fundsMarketingConfiguration;
  // noinspection BadExpressionStatementJS
  import(
  /* webpackChunkName: "[request]" */ // eslint-disable-line no-inline-comments
  "./apps/" + fundsMarketingConfiguration.appType);
};

window.unmountFundsMarketingApp = function unmountReactApp() {
  _reactDom2.default.unmountComponentAtNode(document.getElementById("react-app"));
};

window.addEventListener("popstate", function (event) {

  if (document.readyState === "complete") {
    event.stopImmediatePropagation();
    if (!(0, _ramda.isNil)(window.fundsMarketingConfiguration.backButtonHandler)) {
      window.fundsMarketingConfiguration.backButtonHandler(event);
    }
  }
}, false);

window.addEventListener("hashchange", function (event) {
  if (!window.fundsMarketingConfiguration.inAppClick && document.readyState === "complete" && !(0, _ramda.isNil)(window.fundsMarketingConfiguration.hashChangeHandler)) {
    window.fundsMarketingConfiguration.hashChangeHandler(event);
  }
  window.fundsMarketingConfiguration.inAppClick = false;
}, false);